module.exports = __webpack_public_path__ + "static/img/home.4e7130e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/home.png
// module id = d/S4
// module chunks = 7